import { useMemo } from 'react';
import {
  ProductType,
  Session,
  useCountryPriceTiers,
  useRecruitment,
} from '@app/api';
import { usePlan } from 'queries';
import { getRelevantProducts } from 'lib/planAndOffer';
import { PriceChips } from 'components';

interface Props {
  session: Session;
  sessionLinkId: string;
  duration?: number;
}

export const SessionLinkPriceChips = ({
  session,
  sessionLinkId,
  duration: durationProps,
}: Props) => {
  const duration = durationProps || session.duration;

  const { data: recruitment } = useRecruitment(session.recruitmentId);
  const countryPriceGroupIds = useCountryPriceTiers(recruitment?.countryKeys);

  const { data: plan } = usePlan(session.planId);
  const products = useMemo(
    () =>
      getRelevantProducts(
        plan?.products.filter((l) => l.product?.type !== ProductType.FEATURE),
        {
          sessionLinkId,
          countryPriceGroupIds,
        },
      ),
    [plan, sessionLinkId, countryPriceGroupIds],
  );

  if (countryPriceGroupIds.length > 1) {
    return (
      <PriceChips
        products={products.filter((l) => !l.countryPriceGroupId)}
        duration={duration}
        countries={recruitment?.countryKeys.length}
      />
    );
  }
  return <PriceChips products={products} duration={duration} />;
};
